module.exports = __webpack_public_path__ + "src/assets/img/musicbox.2f58c1c3.png";